<template>
  <div>
    <div
      class="sc-launcher-wrapper"
      :class="{opened: widget.isOpen}"
      @click.prevent="toggle"
    >
      <slot name="launcher" :widget="widget">
        <div
          class="sc-launcher"
          :style="{backgroundColor: colors.launcher.bg}"
        >
          <div
            v-if="chat.newMessagesCount && !widget.isOpen"
            class="sc-new-messsages-count"
          >{{chat.newMessagesCount}}</div>
          <img v-if="widget.isOpen" class="sc-closed-icon" :src="icons.closeIconLauncher" :alt="'close'" />
          <img v-else class="sc-open-icon" :src="icons.openIcon" :alt="'open'" />
        </div>
      </slot>
    </div>
    <div v-if="widget.isOpen"></div>
    <chat-window>
      <template v-slot:header>
        <slot name="header"></slot>
      </template>
      <template v-slot:user-avatar="scopedProps">
        <slot name="user-avatar" :user="scopedProps.user" :message="scopedProps.message"></slot>
      </template>
      <template v-slot:pre-chat>
        <slot name="pre-chat"></slot>
      </template>
      <template v-slot:post-chat>
        <slot name="post-chat"></slot>
      </template>
    </chat-window>
  </div>
</template>
<script>
import ChatWindow from "./ChatWindow";
export default {
  name: "Launcher",
  components: {
    ChatWindow
  },
  inject: {
    chat: {
      type: Object
    },
    widget: {
      type: Object
    },
    colors: {
      type: Object
    },
    icons: {
      type: Object
    }
  },
  methods: {
    open() {
      this.widget.isOpen = true;
    },
    close() {
      this.widget.isOpen = false;
    },
    toggle() {
      this.widget.isOpen = !this.widget.isOpen;
    }
  }
};
</script>
<style scoped>
.sc-launcher {
  width: 60px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  right: 25px;
  bottom: 25px;
  border-radius: 50%;
  box-shadow: none;
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
}

.sc-launcher:before {
  content: "";
  position: relative;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  transition: box-shadow 0.2s ease-in-out;
}

.sc-launcher .sc-open-icon,
.sc-launcher .sc-closed-icon {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 25px;
  bottom: 25px;
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
}

.sc-launcher .sc-closed-icon {
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
  width: 60px;
  height: 60px;
}

.sc-launcher .sc-open-icon {
  padding: 20px;
  box-sizing: border-box;
  opacity: 1;
}

.sc-launcher.opened .sc-open-icon {
  transform: rotate(-90deg);
  opacity: 1;
}

.sc-launcher.opened .sc-closed-icon {
  transform: rotate(-90deg);
  opacity: 1;
}

.sc-launcher.opened:before {
  box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
}

.sc-launcher:hover {
  box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
}

.sc-new-messsages-count {
  position: absolute;
  top: -3px;
  left: 41px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background: #ff4646;
  color: white;
  text-align: center;
  margin: auto;
  font-size: 12px;
  font-weight: 500;
}
</style>
